export class GitTreeResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "commitSha",
            "baseName": "commitSha",
            "type": "string",
            "format": ""
        },
        {
            "name": "entries",
            "baseName": "entries",
            "type": "Array<GitTreeEntry>",
            "format": ""
        },
        {
            "name": "nextToken",
            "baseName": "nextToken",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GitTreeResponse.attributeTypeMap;
    }
    constructor() {
    }
}
